
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebfd9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebfd9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $hCyg7 = parcelRequire("hCyg7");
// Get the form and its input fields
const $7ee8781d9217a29b$var$saveForm = document.forms.saveForm;
const { name: $7ee8781d9217a29b$var$name, username: $7ee8781d9217a29b$var$username, email: $7ee8781d9217a29b$var$email, city: $7ee8781d9217a29b$var$city, zipcode: $7ee8781d9217a29b$var$zipcode, phone: $7ee8781d9217a29b$var$phone } = $7ee8781d9217a29b$var$saveForm;
let $7ee8781d9217a29b$var$isFormSubmitted = false;
// Generate the form values object
const $7ee8781d9217a29b$var$generateValues = ()=>{
    const data = new FormData($7ee8781d9217a29b$var$saveForm);
    return {
        name: data.get("name"),
        username: data.get("username"),
        email: data.get("email"),
        address: {
            city: data.get("city"),
            zipcode: data.get("zipcode")
        },
        phone: data.get("phone")
    };
};
// Validation functions for specific fields
const $7ee8781d9217a29b$var$isValidZip = (zip)=>{
    const regex = /^[0-9-]+$/;
    return regex.test(zip);
};
const $7ee8781d9217a29b$var$isValidPhone = (phone)=>{
    const regex = /^[0-9\s()-]+$/;
    return regex.test(phone);
};
const $7ee8781d9217a29b$var$isValidCity = (city)=>{
    const regex = /^[a-zA-Z\s]+$/;
    return regex.test(city);
};
// Set error message and styling if input is invalid
const $7ee8781d9217a29b$var$setValidationError = (input, condition, errorKey, errorMessage)=>{
    const errorElement = document.getElementById(errorKey);
    if (condition) {
        input.classList.add("error-input");
        errorElement.textContent = errorMessage;
        return {
            [errorKey]: errorMessage
        };
    } else {
        input.classList.remove("error-input");
        errorElement.textContent = "";
        return {};
    }
};
// Validate entire form and collect errors
const $7ee8781d9217a29b$var$validateForm = (values)=>{
    const errors = {
        ...$7ee8781d9217a29b$var$setValidationError($7ee8781d9217a29b$var$name, values.name.length < 5, "nameError", "Name should be more than 5 characters"),
        ...$7ee8781d9217a29b$var$setValidationError($7ee8781d9217a29b$var$username, values.username.length < 5, "usernameError", "Username should be more than 5 characters"),
        ...$7ee8781d9217a29b$var$setValidationError($7ee8781d9217a29b$var$email, !values.email.includes("@"), "emailError", "Email should include @"),
        ...$7ee8781d9217a29b$var$setValidationError($7ee8781d9217a29b$var$city, !$7ee8781d9217a29b$var$isValidCity(values.address.city), "cityError", "You must add a city"),
        ...$7ee8781d9217a29b$var$setValidationError($7ee8781d9217a29b$var$zipcode, !$7ee8781d9217a29b$var$isValidZip(values.address.zipcode), "zipError", "Zipcode must only be digits or a hyphen"),
        ...$7ee8781d9217a29b$var$setValidationError($7ee8781d9217a29b$var$phone, !$7ee8781d9217a29b$var$isValidPhone(values.phone), "phoneError", "You must add a phone number")
    };
    // Display error messages on the page
    Object.entries(errors).forEach(([key, value])=>{
        document.getElementById(key).textContent = value;
    });
    // Check if there are any errors in the form
    return !Object.values(errors).some(Boolean);
};
// Add listeners for input change to validate in real-time
[
    $7ee8781d9217a29b$var$name,
    $7ee8781d9217a29b$var$username,
    $7ee8781d9217a29b$var$email,
    $7ee8781d9217a29b$var$city,
    $7ee8781d9217a29b$var$zipcode,
    $7ee8781d9217a29b$var$phone
].forEach((input)=>{
    input.addEventListener("input", ()=>{
        $7ee8781d9217a29b$var$validateSingleInput(input);
    });
});
// Validate a single input field
const $7ee8781d9217a29b$var$validateSingleInput = (input)=>{
    if (!$7ee8781d9217a29b$var$isFormSubmitted) return;
    switch(input.name){
        case "name":
            $7ee8781d9217a29b$var$setValidationError($7ee8781d9217a29b$var$name, $7ee8781d9217a29b$var$name.value.length < 5, "nameError", "Name should be more than 5 characters");
            break;
        case "username":
            $7ee8781d9217a29b$var$setValidationError($7ee8781d9217a29b$var$username, $7ee8781d9217a29b$var$username.value.length < 5, "usernameError", "Username should be more than 5 characters");
            break;
        case "email":
            $7ee8781d9217a29b$var$setValidationError($7ee8781d9217a29b$var$email, !$7ee8781d9217a29b$var$email.value.includes("@"), "emailError", "Email should include @");
            break;
        case "city":
            $7ee8781d9217a29b$var$setValidationError($7ee8781d9217a29b$var$city, !$7ee8781d9217a29b$var$isValidCity($7ee8781d9217a29b$var$city.value), "cityError", "You must add a city");
            break;
        case "zipcode":
            $7ee8781d9217a29b$var$setValidationError($7ee8781d9217a29b$var$zipcode, !$7ee8781d9217a29b$var$isValidZip($7ee8781d9217a29b$var$zipcode.value), "zipError", "Zipcode must only be digits or a hyphen");
            break;
        case "phone":
            $7ee8781d9217a29b$var$setValidationError($7ee8781d9217a29b$var$phone, !$7ee8781d9217a29b$var$isValidPhone($7ee8781d9217a29b$var$phone.value), "phoneError", "You must add a phone number");
            break;
        default:
            break;
    }
};
// Function to save the user's data to an external source
const $7ee8781d9217a29b$var$saveInformation = (values)=>fetch("https://jsonplaceholder.typicode.com/users", {
        body: JSON.stringify(values),
        method: "POST",
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    });
// Handle the save button click event
const $7ee8781d9217a29b$var$saveBtn = document.getElementById("saveBtn");
$7ee8781d9217a29b$var$saveBtn.onclick = ()=>{
    $7ee8781d9217a29b$var$isFormSubmitted = true;
    const values = $7ee8781d9217a29b$var$generateValues();
    if ($7ee8781d9217a29b$var$validateForm(values)) {
        $7ee8781d9217a29b$var$saveInformation(values);
        (0, $hCyg7.saveUser)(values);
        $7ee8781d9217a29b$var$saveForm.reset();
        $7ee8781d9217a29b$var$isFormSubmitted = false;
    }
};


//# sourceMappingURL=index.15335df5.js.map
